import {css} from 'lit';
export const styles = css`:host {
  --avatar-size: var(--chat-list-avatar-size, 60px);
  --background-color: var(--contrast-light);
  --color: var(--contrast-dark);
  --color-secondary: var(--dark-text-secondary);

  position: relative;
  display: block;
  padding: 16px;
  border-radius: var(--border-radius);
  background-color: var(--background-color);
  color: var(--color);
  transition: background-color var(--transition-duration)
    var(--transition-timing);
  cursor: pointer;
}

.dot-menu-trigger {
  width: 0;
  padding: 0;
  overflow: hidden;
  border: var(--chat-msg-menu-trigger-border);
  border-radius: 8px;
  font-size: 22px;
  background-color: var(--gray-200);
  transition: background-color,
    width var(--transition-duration) var(--transition-timing);
}

@media (hover: hover) {
    .dot-menu-trigger:hover {
      border-color: var(--gray-200);
    }
  }

.dot-menu-trigger:active {
    border-color: var(--gray-000);
  }

.content {
  display: flex;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

slot::slotted(*) {
  margin-right: 16px;
}

.info {
  flex: 1;
  min-width: 1px;
}

.top {
  display: flex;
  justify-content: space-between;
}

.title {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  margin: 0 8px 4px 0;
  font-size: var(--font-size-md);
  overflow: hidden;
}

.date {
  font-size: var(--font-size-xs);
  color: var(--color-secondary);
  white-space: nowrap;
}

.message {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: var(--font-size-sm);
  color: var(--color-secondary);
  word-break: break-word;
  margin-right: 40px;
}

ef-badge {
  position: absolute;
  bottom: 16px;
  right: 16px;
  height: 26px;
  width: 26px;
  border-radius: 50%;
}

xs-chat-menu {
  position: absolute;
  top: 8px;
  right: 16px;
}

:host([focus-within]) .dot-menu-trigger {
  width: 32px;
}

:host(:focus-within) .dot-menu-trigger {
  width: 32px;
}

:host(.focus-visible) {
  outline: 1px solid var(--link-focus-outline);
  outline-offset: -4px;
  border-radius: var(--border-radius);
}

:host(:focus-visible) {
  outline: 1px solid var(--link-focus-outline);
  outline-offset: -4px;
  border-radius: var(--border-radius);
}

@media (hover: hover) {
  :host(:hover) .dot-menu-trigger {
    background-color: var(--gray-000);
    width: 32px;
  }
}

:host(:active) {
  --background-color: var(--gray-200);
}

:host([active='true']) {
  --background-color: var(--primary-bg);
  --color: var(--contrast-light);
  --color-secondary: var(--contrast-light);
}

:host([menuOpen]) { /* Increase z-Index on menu open so that menu would be above below items */
}

:host([menuOpen]) .dot-menu-trigger {
    width: 32px;
  }

:host([menuOpen]) {

  z-index: 1;
}
`;
export default styles;
